import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { StaticMessage } from '@shared/enums';
import { DprDetailCopyOption } from '@dpr-details/models/dpr-details-copy-option.model';

@Component({
  selector: 'app-dpr-details-copy-action-modal',
  templateUrl: './dpr-details-copy-action-modal.component.html',
  styleUrls: ['./dpr-details-copy-action-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DprDetailsCopyActionModalComponent implements OnInit {
  title: string;
  optionsForm: FormGroup = new FormGroup({});
  staticMessage = StaticMessage;

  constructor(
    public dialogRef: MatDialogRef<DprDetailsCopyActionModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      title: string;
      options: DprDetailCopyOption[];
    }
  ) {
    this.title = $localize`:@@dprDetails.dprDetailsCopyActionModal.title:${this.data.title}:activityIdentifier:: Specify the activity details to be copied`;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCopy(): void {
    const formValue = this.optionsForm.value;

    this.dialogRef.close(
      this.data.options.map((x) => ({
        ...x,
        value: formValue[x.id.toString()],
      }))
    );
  }

  trackOptions(_index: number, option: DprDetailCopyOption): number {
    return option.id;
  }

  //#region Private Methods

  private buildForm(): void {
    this.data.options.forEach((x) => {
      this.optionsForm.addControl(
        x.id.toString(),
        new FormControl<boolean | null>(x.value)
      );
    });
  }

  //#endregion
}
